import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 38.8243,
		cy: 38.8243,
		rx: 38.8243,
		ry: 38.8243,
		fill: "#888888"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M52.5526 25.8848H25.1484C23.9375 25.8861 22.7765 26.3677 21.9202 27.2239C21.064 28.0802 20.5824 29.2412 20.5811 30.4521V50.0265C20.5824 51.2375 21.064 52.3984 21.9202 53.2547C22.7765 54.111 23.9375 54.5926 25.1484 54.5939H52.5526C53.7635 54.5926 54.9245 54.111 55.7808 53.2547C56.637 52.3984 57.1186 51.2375 57.1199 50.0265V30.4521C57.1186 29.2412 56.637 28.0802 55.7808 27.2239C54.9245 26.3677 53.7635 25.8861 52.5526 25.8848ZM51.3961 33.4397L39.6514 42.5744C39.4224 42.7524 39.1406 42.8491 38.8505 42.8491C38.5604 42.8491 38.2786 42.7524 38.0496 42.5744L26.3049 33.4397C26.1669 33.3355 26.051 33.2049 25.964 33.0555C25.8769 32.9061 25.8204 32.7409 25.7977 32.5695C25.775 32.3981 25.7866 32.2238 25.8318 32.0569C25.8771 31.89 25.955 31.7338 26.0612 31.5973C26.1673 31.4608 26.2995 31.3467 26.4501 31.2618C26.6007 31.1768 26.7667 31.1226 26.9384 31.1023C27.1101 31.0821 27.2842 31.0961 27.4504 31.1437C27.6166 31.1913 27.7718 31.2714 27.9068 31.3795L38.8505 39.8911L49.7942 31.3795C50.0679 31.1728 50.4119 31.0822 50.7518 31.1272C51.0918 31.1721 51.4004 31.3491 51.6108 31.6198C51.8213 31.8906 51.9168 32.2332 51.8766 32.5738C51.8364 32.9143 51.6638 33.2254 51.3961 33.4397Z",
		fill: "white"
	})]
});
export default SvgEmail;
